// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vSkT5{padding:0}.QqNdL{padding:16px}.bT4fK{max-height:400px;overflow-y:auto;flex:1;padding:8px 16px}.ezYHZ{margin:0;transition:width .3s ease-in-out}.SLi4B{transition:width .3s ease-in-out}.gLEWN{padding:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `vSkT5`,
	"header": `QqNdL`,
	"popoverContent": `bT4fK`,
	"form": `ezYHZ`,
	"formColumn": `SLi4B`,
	"actions": `gLEWN`
};
export default ___CSS_LOADER_EXPORT___;
